import { render, staticRenderFns } from "./showActivityEdition.vue?vue&type=template&id=644ae91a"
import script from "./showActivityEdition.vue?vue&type=script&lang=js"
export * from "./showActivityEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports